module.exports = __webpack_public_path__ + "static/media/S13_black.08dd7a6d.png";